const tabs = document.querySelectorAll('[data-tab-target]')
const tabContents = document.querySelectorAll('[data-tab-content]')

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget)
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target.classList.add('active')
  })
})

const mobileTabs = document.querySelectorAll('.mobile-tab-title')

mobileTabs.forEach(mobileTab => {
  mobileTab.addEventListener('click', () => {
    
    mobileTabs.forEach(item => {
      //Close any other open tabs except the one clicked
      if (item !== mobileTab) {
        item.classList.remove('active')
        item.nextElementSibling.style.maxHeight = null
        item.querySelectorAll('.plus')[0].style.display = "block";
        item.querySelectorAll('.minus')[0].style.display = "none";
      }
    })

    mobileTab.classList.toggle('active')
    const plus = mobileTab.querySelectorAll('.plus')[0]
    const minus = mobileTab.querySelectorAll('.minus')[0]
    if (plus.style.display === "none") {
      plus.style.display = "block";
      minus.style.display = "none";
    } else {
      plus.style.display = "none";
      minus.style.display = "block";
    }
    
    const mobileTabContents = mobileTab.nextElementSibling
    if (mobileTabContents.style.maxHeight) {
      mobileTabContents.style.maxHeight = null
    }
    else {
      mobileTabContents.style.maxHeight = mobileTabContents.scrollHeight + 'px'
    }
  })
})